<div class="window medium">
    <h2><svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-driver"></use></svg>
    Sign Up To MTData EWD</h2>
        <form [formGroup]="form" novalidate (ngSubmit)="OnSave(form.valid)">
            <label>Email</label>
            <div class="inputWrap">
                <input type="text" placeholder="Email" formControlName="email">
                <div *ngIf="!form.controls['email'].valid && (form.controls['email'].touched || submitted)" class="validation">
                    <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                    <span>Required field</span>
                </div>
            </div><!-- inputWrap -->
            <label>Driver Name</label>
            <div class="inputDoubleWrap">
                <div class="inputWrap">	
                    <input type="text" placeholder="First Name" formControlName="firstName">
                    <div *ngIf="!form.controls['firstName'].valid && (form.controls['firstName'].touched || submitted)"  class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                    </div>
                </div><!-- inputWrap -->
                <div class="inputWrap">		
                    <input type="text" placeholder="Last Name" formControlName="lastName">
                    <div *ngIf="!form.controls['lastName'].valid && (form.controls['lastName'].touched || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                        </div>
                </div><!-- inputWrap -->
            </div><!-- inputDoubleWrap -->
            <label>Phone Number</label>
            <div class="inputDoubleWrap">
                <div class="inputWrap">		
                    <input type="text" placeholder="Phone Number" formControlName="phone">
                    <div *ngIf="!form.controls['phone'].valid && (form.controls['phone'].touched || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                        </div>
                </div><!-- inputWrap -->
            </div><!-- inputDoubleWrap -->								
            <label>Address</label>
            <div class="inputWrap">
                <input type="text" placeholder="Address 1" formControlName="address1">
                <div *ngIf="!form.controls['address1'].valid && (form.controls['address1'].touched || submitted)" class="validation">
                    <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                    <span>Required field</span>
                    </div>
            </div><!-- inputWrap -->
            <div class="inputWrap">		
                <input type="text" placeholder="Address 2" formControlName="address2">
            </div><!-- inputWrap -->
            <div class="inputDoubleWrap">
                <div class="inputWrap">		
                    <input type="text" placeholder="City or Suburb" formControlName="city">
                    <div *ngIf="!form.controls['city'].valid && (form.controls['city'].touched || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                        </div>
                </div>
                <div class="inputWrap">		
                    <input type="text" placeholder="Post Code" formControlName="zipCode">
                    <div *ngIf="!form.controls['zipCode'].valid && (form.controls['zipCode'].touched || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                        </div>
                </div>
            </div>
            <div class="inputDoubleWrap">
                <div class="inputWrap withType">		
                    <div class="select">
                        <select name="" id="" formControlName="state">
                            <option value="" selected disabled hidden>State</option>        
                            <option *ngFor="let state of states" [value]="state">{{state}}</option>                                   												
                        </select>
                        <div *ngIf="!form.controls['state'].valid && (form.controls['state'].touched || submitted)" class="validation">
                            <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                            <span>Required field</span>
                        </div>
                    </div><!-- select -->
                    <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-chev-down"></use></svg>
                </div><!-- inputWrap -->
            </div><!-- inputDoubleWrap -->
            <label>Unique Identification Number / Date Of Birth</label>
            <div class="inputDoubleWrap">
                <div class="inputWrap">		
                    <input type="text" placeholder="Unique Identification Number" formControlName="udi" [readonly]="true">
                </div>
                <div class="inputWrap">		
                    <my-date-picker [options]="dateOfBirthOptions" formControlName="dateOfBirth"></my-date-picker>
                    <div *ngIf="!form.controls['dateOfBirth'].valid && (form.controls['dateOfBirth'].touched  || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                    </div>
                </div>
            </div>            
            <label>Base Time Zone</label>
            <div class="inputDoubleWrap">
                <div class="inputWrap withType">		
                    <div class="select">
                        <select name="" id="" formControlName="baseState">
                            <option value="" selected disabled hidden>State</option>        
                            <option *ngFor="let state of states" [value]="state">{{state}}</option>                                   												
                        </select>
                        <div *ngIf="!form.controls['state'].valid && (form.controls['state'].touched || submitted)" class="validation">
                            <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                            <span>Required field</span>
                        </div>
                    </div>
                    <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-chev-down"></use></svg>
                </div>
            </div>
            <label>Drivers Licence # and Expiry </label>
            <div class="inputDoubleWrap">
                <div class="inputWrap">		
                    <input type="text" placeholder="Licence #" formControlName="licenceNumber">
                    <div *ngIf="!form.controls['licenceNumber'].valid && (form.controls['licenceNumber'].touched || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                        </div>
                </div><!-- inputWrap -->
                <div class="inputWrap">		
                    <input type="text" placeholder="Licence Type" formControlName="licenceType">
                    <div *ngIf="!form.controls['licenceType'].valid && (form.controls['licenceType'].touched  || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                        </div>
                </div>
            </div>
            <div class="inputDoubleWrap">
                <div class="inputWrap withType">
                    <my-date-picker [options]="licenceDateOptions" formControlName="licenceExpiry"></my-date-picker>
                    <div *ngIf="!form.controls['licenceExpiry'].valid && (form.controls['licenceExpiry'].touched  || submitted)" class="validation">
                        <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                        <span>Required field</span>
                        </div>
                </div>
                <div class="inputWrap withType">		
                    <div class="select">
                        <select name="" id="" formControlName="licenceState">
                            <option value="" selected disabled hidden>State</option>        
                            <option *ngFor="let state of licencestates" [value]="state">{{state}}</option>                                   												
                        </select>
                        <div *ngIf="!form.controls['state'].valid && (form.controls['state'].touched || submitted)" class="validation">
                            <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                            <span>Required field</span>
                        </div>
                    </div>
                    <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-chev-down"></use></svg>
                </div>
            </div>
            <div id="recaptcha_elem"></div>            
            <br>
            <button id="signUpSubmit" class="cta primary ladda leftFloat" data-style="slide-right" disabled="true" [ladda]="isLoading"><span>
                <svg class="icon">
                    <use xlink:href="assets/iconography/symbol-defs.svg#icon-send"></use>
                </svg>
                Submit (confirm)</span>
            </button>
            <div>
            </div>
        </form>


    <button class="cta primary rightFloat" (click)="closeModal()">
        <span><svg class="icon">
                <use xlink:href="assets/iconography/symbol-defs.svg#icon-cancel"></use>
            </svg>Cancel
        </span>
    </button>
</div>
